// extracted by extract-css-chunks-webpack-plugin
module.exports = {"newHamburgerPlaceHolder":"_1KKKz","sliderWrapper":"_3QKEL","menuLink":"_2LpG3","iconWrapper":"_2DhHu","menuText":"_38c4W"};